import * as React from 'react';

import { EventFieldOptions, ReportType } from '../api/clients';

import ErrorOverlay from '../../components/ErrorOverlay';
import LoadingOverlay from '../../components/LoadingOverlay';
import useGetEventReportFieldOptions from '../api/hooks/event-report/useGetEventReportFieldOptions';

const FlightEventFieldOptionsContext = React.createContext<EventFieldOptions>(undefined!);

// eslint-disable-next-line max-len
export function FlightEventFieldOptionsProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const flightEventFieldOptions = useGetEventReportFieldOptions(ReportType.FlightEventReport);

  if (flightEventFieldOptions.isLoading) {
    return (
      <LoadingOverlay />
    );
  }

  if (flightEventFieldOptions.status === 'error') {
    return (
      <ErrorOverlay
        title={flightEventFieldOptions?.error?.title}
        message="An error occurred retrieving data"
      />
    );
  }

  if (flightEventFieldOptions.data) {
    return (
      <FlightEventFieldOptionsContext.Provider value={flightEventFieldOptions.data}>
        {children}
      </FlightEventFieldOptionsContext.Provider>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
}

export const useFlightEventFieldOptions = () => React.useContext(FlightEventFieldOptionsContext);
